var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5796 67.0856C70.8493 69.3552 70.8493 73.0329 68.5796 75.2989C66.31 77.5686 62.6323 77.5686 60.3663 75.2989C58.0966 73.0292 58.0966 69.3516 60.3663 67.0856C62.636 64.8159 66.3136 64.8159 68.5796 67.0856",
    stroke: "#0B907B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2462 67.0855C30.5159 69.3552 30.5159 73.0329 28.2462 75.2989C25.9766 77.5685 22.2989 77.5685 20.0329 75.2989C17.7669 73.0292 17.7632 69.3515 20.0329 67.0855C22.3026 64.8195 25.9766 64.8159 28.2462 67.0855",
    stroke: "#0B907B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6654 14.6667H51.332C53.356 14.6667 54.9987 16.3094 54.9987 18.3334V55.0001H7.33203",
    stroke: "#0B907B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.332 71.1921H10.9987C8.9747 71.1921 7.33203 69.5494 7.33203 67.5254V47.6667",
    stroke: "#0B907B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25.6667H70.851C72.3507 25.6667 73.7 26.5797 74.2537 27.9731L80.1423 42.6911C80.487 43.5564 80.6667 44.4804 80.6667 45.4118V67.2211C80.6667 69.2451 79.024 70.8878 77 70.8878H70.2863",
    stroke: "#0B907B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.667 71.2069H29.957",
    stroke: "#0B907B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6667 51.3334H66V36.6667H77.7333",
    stroke: "#0B907B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 14.6667H25.6654",
    stroke: "#0B907B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 25.6667H18.332",
    stroke: "#0B907B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9987 36.6667H7.33203",
    stroke: "#0B907B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/Delivery.884d2c5120d47d051a18bc732c22c195.svg";
export { ForwardRef as ReactComponent };